module.exports = __webpack_public_path__ + "static/media/facebok-logo.2dea3960.svg";